/**
 * 文件上传
 */
/**
 * 传参格式
 * let option = {
    multiple: !0, 是否可以多选 true false
    params: {
      bucket, 存储桶bucket
      region, 存储桶region
      previewUrl: preview_url 预览地址前缀eg:https://ddbes.com
    },
    getFileId: get_upload_ids, // 获取上传时id数组的api
    getAuthFunction: get_upload_auth, // 获取上传时的权限
    accept: 'image/*' //选择文件上传类型
  };
 */
export default {
  data() {
    return {
      list: [],
      cos: null,
      total: 0
    };
  },
  methods: {
    handleClickUpload(options) {
      const _this = this;
      this.total = 0;
      const defaultOption = {
        type: '',
        multiple: !0,
        accept: '*',
        change: null,
        params: {},
        getFileId: null,
        getAuthFunction: null,
        id: '_ddbes_upload_'
      };
      options = Object.assign(defaultOption, options);
      let upload = document.getElementById(options.id);
      if (upload) {
        document.body.removeChild(upload);
      };
      // 手动创建一个上传input
      upload = document.createElement('input');
      upload.id = options.id;
      upload.type = 'file';
      upload.accept = options.accept;
      upload.multiple = options.multiple;
      upload.onchange = changeFunction;
      upload.style.cssText = 'width: 0; height: 0; position: fixed; top: 0; left: 0';
      document.body.appendChild(upload);
      if (options.accept === '*') {
        upload.click();
      } else {
        setTimeout(() => {
          upload.click();
        }, 0);
      }
      // change
      function changeFunction(e) {
        _this.$emit('change', e);
        if (options.change && typeof options.change === 'function') {
          options.change(e);
        } else {
          selectedFile(e.target.files, options.params);
        }
        _this.$emit('upload-start');
      };
      // upload
      async function selectedFile(e, params = {}) {
        // console.log(e);
        // let newArr = new Array(e.length);
        let selectNum = e.length;
        if (options.params.isupdate == 1) {
          if (selectNum > 5) {
            alert('最多上传5张图');
            return;
          }
        }
        params.type = options.type;
        await _this.initCos(options.getAuthFunction, params)
        _this.list = [];
        let files = e;
        let ids = [];
        let getFileId = options.getFileId;
        _this.total = files.length;
        if (!_this.total) return;
        if (!getFileId || typeof getFileId !== 'function') {
          this.$emit('error');
          throw Error('getFileId必须是获取文件id的async函数');
        }
        let resIds = await getFileId(files, files.length);
        if (resIds.data && Array.isArray(resIds.data)) {
          ids = resIds.data;
          files = [].slice.call(files);
          let list = [].map.call(files, (f, idx) => {
            f.id = ids[idx] + _this._getExt(f.name);
            return {
              Bucket: params.bucket,
              Region: params.region,
              Key: `${f.id}`,
              sort: ids[idx],
              Body: f,
              FilePath: f.name
            };
          });
          // console.log(list);
          _this.cos.uploadFiles({
            files: list,
            onFileFinish(err, data, options) {
              _this.$emit('upload-finish', {
                name: options.FilePath,
                src: `${params.previewUrl}/${options.Key}`,
                isupdate: params.isupdate || !1,
                sort: _this.getFileName(options.Key),
                selectNum: selectNum
              });
            }
          });
        } else {
          _this.$emit('error');
          throw Error('getFileId返回失败');
        }
      };
    },

    // init cos
    initCos(getAuthFunction = null, params) {
      const _this = this;
      return import('cos-js-sdk-v5')
        .then(cos => {
          const Cos = cos;
          this.cos = new Cos({
            ChunkSize: 10485760,
            SliceSize: 10485760 * 2,
            FileParallelLimit: 1000,
            ChunkParallelLimit: 100,
            getAuthorization(options, callback) {
              if (!getAuthFunction || typeof getAuthFunction !== 'function') {
                throw Error('请输入获取权限函数');
              }
               getAuthFunction()
                .then(data => {
                  // console.log(data);
                  const data1 = data.data;
                  callback({
                    TmpSecretId: data1.credentials && data1.credentials.tmpSecretId,
                    TmpSecretKey: data1.credentials && data1.credentials.tmpSecretKey,
                    XCosSecurityToken: data1.credentials && data1.credentials.sessionToken,
                    ExpiredTime: data1.expiredTime
                  });
                });
            }
          });
          this.cos && this.cos.on('list-update', data => {
            let list = [];
            for (let i = 0, len = data.list.length; i < len; i++) {
              if (data.list[i].state === 'success') {
                data.list[i].src = `${params.previewUrl}/${data.list[i].Key}`;
                list.push(data.list[i]);
                this.$emit('list-update', list, params.type);
              }
            }
            // if (list.length !== 0 && list.length === _this.total) {
            //   list.length !== 0 && (this.$emit('list-update', list, params.type));
            // }
          });
          return Promise.resolve()
        });
    },
    // 获取扩张名
    _getExt(value) {
      if (!value) return;
      let idx = value.lastIndexOf('.');
      return (idx > -1
        ? value.substring(idx) : '');
    },
    // 排序
    sortData(a, b) {
      return a.sort - b.sort
    },
    // 去掉后缀
    getFileName(data) {
      return data.substring(0, data.indexOf('.'));
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/upload.js